import type { PresentationModule } from '../../../presentation/types';
import { mintBusiness } from './content';
import { MintBusinessScene } from './scenes/MintBusinessScene';

export const mintBusinessModule: PresentationModule = {
  id: 'mint-business',
  label: 'MINT Business',
  priority: 'flagship',
  parent: 'mint',
  scenes: [
    { ...mintBusiness, module: 'mint-business', create: (resolved) => new MintBusinessScene(resolved) },
  ],
};
